import React from 'react';

import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const QuickAddSection = ({ recentFoods, onQuickAdd, onScanBarcode, onVoiceInput }) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4">
        Quick Add
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
        <Button
          variant="outline"
          onClick={onScanBarcode}
          iconName="ScanBarcode"
          iconPosition="left"
          className="justify-start"
        >
          Scan Barcode
        </Button>
        <Button
          variant="outline"
          onClick={onVoiceInput}
          iconName="Mic"
          iconPosition="left"
          className="justify-start"
        >
          Voice Input
        </Button>
        <Button
          variant="outline"
          onClick={() => {}}
          iconName="Camera"
          iconPosition="left"
          className="justify-start"
        >
          Photo Recognition
        </Button>
      </div>
      <div>
        <div className="flex items-center justify-between mb-3">
          <h4 className="text-sm md:text-base font-medium text-foreground">
            Recent Foods
          </h4>
          <Button
            variant="link"
            size="sm"
            onClick={() => {}}
            className="h-auto p-0"
          >
            View All
          </Button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {recentFoods?.map((food) => (
            <button
              key={food?.id}
              onClick={() => onQuickAdd(food)}
              className="flex flex-col items-center gap-2 p-3 bg-muted/50 rounded-lg transition-smooth hover:bg-muted hover-lift press-scale"
            >
              <div className="h-12 w-12 md:h-14 md:w-14 rounded-lg overflow-hidden bg-background">
                <Image
                  src={food?.image}
                  alt={food?.imageAlt}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="text-center w-full">
                <p className="text-xs md:text-sm font-medium text-foreground truncate">
                  {food?.name}
                </p>
                <p className="text-xs caption text-muted-foreground">
                  {food?.calories} kcal
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAddSection;